// extracted by mini-css-extract-plugin
export var radioInputRow = "F_t2";
export var radioInputColumn = "F_t3";
export var inputOptionRow = "F_qq";
export var inputOptionColumn = "F_qr";